import { Component, OnInit, TemplateRef, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ContaCreditoService, ExtratoContaCreditoService, DominiosService } from '../shared/services/acordo-ressarcimento/api/services';
import { AppComponent } from '../app.component';
import { ContaCredito, Paginacao, LinhaExtratoContaCreditoPaginado, StatusLinhaCredito, LinhaExtratoContaCredito } from '../shared/services/acordo-ressarcimento/api/models';
import { LoadingService } from '../shared/services/components/loading.service';
import { ConsultarTransacaoCreditoService } from '../conciliacao-validacao/conciliacao-validacao.service';
import { PsModalLoadingComponent } from 'porto-seguro-guide';

@Component({
  selector: 'app-conciliacao-extrato',
  templateUrl: './conciliacao-extrato.component.html',
  styleUrls: ['./conciliacao-extrato.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ConciliacaoExtratoComponent implements OnInit {
  public formPesquisa: FormGroup;
  public extratoPaginado: LinhaExtratoContaCreditoPaginado;
  source = [];
  columnsTemplate = [];
  public page: Paginacao;
  public situacoesExtrato: StatusLinhaCredito[];
  public listaContasCredito: ContaCredito[];
  public loadingLista = false;
  public dadosLinha: LinhaExtratoContaCredito[] = [];
  public linhasSelecionadas: number[] = [];
  public isEscritorioLogado: boolean = JSON.parse(sessionStorage.getItem('isEscritorio'));

  @ViewChild('templateDataExtrato') private templateDataExtrato: TemplateRef<any>;
  @ViewChild('templateValorExtrato') private templateValorExtrato: TemplateRef<any>;
  @ViewChild('templatenumeroTransacao') private templatenumeroTransacao: TemplateRef<any>;
  @ViewChild('templateDetalheExtrato') private templateDetalheExtrato: TemplateRef<any>;
  @ViewChild('templateExcluirExtrato') private templateExcluirExtrato: TemplateRef<any>;
  @ViewChild('ModalConcluidoExtrato') modalConcluidoExtrato: PsModalLoadingComponent;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private loading: LoadingService,
    private contaCreditoService: ContaCreditoService,
    private dominiosService: DominiosService,
    private extratoContaCreditoService: ExtratoContaCreditoService,
    private consultaTransacaoService: ConsultarTransacaoCreditoService,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  ngOnInit() {
    this.columnsTemplate = [
      { label: 'Data', template: this.templateDataExtrato },
      { prop: 'descricaoLancamento', label: 'Lançamento' },
      { prop: 'numeroDocumento', label: 'N° doc' },
      { label: 'Valor', template: this.templateValorExtrato },
      { prop: 'statusLinhaCredito.descricao', label: 'Status' },
      { prop: 'extratoContaCredito.contaCredito.nomeConta', label: 'Conta' },
      { prop: 'extratoContaCredito.codigoExtrato', label: 'Cód. Extrato' },
      { label: 'N° TRANSAÇÃO', template: this.templatenumeroTransacao },
      { label: 'Excluir', template: this.templateExcluirExtrato },
    ];
    if (this.isEscritorioLogado == false) {
      this.columnsTemplate.push({ label: 'Detalhe', template: this.templateDetalheExtrato });
    }

    this.extratoPaginado = undefined;
    this.carregarStatusLinhaCredito();
    this.carregarContasCredito();
    this.criarFormPesquisa();

    if (this.consultaTransacaoService.isRealizaPesquisa
      && this.consultaTransacaoService.isRealizaPesquisa() === true
      && this.consultaTransacaoService.getParametrosPesquisa) {
      this.consultaTransacaoService.setRealizaPesquisa(false);
      this.formPesquisa = this.consultaTransacaoService.getFormPesquisa();
      this.pesquisarExtrato(this.consultaTransacaoService.getParametrosPesquisa()['page']);
    }
  }

  private criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      codigoContaCredito: null,
      dataDe: null,
      dataAte: null,
      lancamento: null,
      codigoStatus: null,
      valorInicial: null,
      valorFinal: null
    });
  }

  public paginar(evt) {
    this.pesquisarExtrato(evt.offset);
  }

  public log(event) {
    console.log(event);
  }

  public carregarContasCredito() {
    this.contaCreditoService.obterContasCredito().subscribe(result => {
      this.listaContasCredito = result;
    });
  }

  private carregarStatusLinhaCredito(): void {
    this.dominiosService.obterSituacoesExtrato().subscribe(result => {
      this.situacoesExtrato = result;
    });
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  public pesquisarExtrato(page) {
    this.loading.open();
    this.extratoPaginado = undefined;

    if (page == undefined) {
      this.linhasSelecionadas = [];
      this.dadosLinha = [];
    }

    var parametros: ExtratoContaCreditoService.ObterLinhasExtratoParams = {
      codigoContaCredito: this.tratarCondicao(this.formPesquisa.value['codigoContaCredito']),
      periodoInicial: this.tratarCondicao(this.formPesquisa.value['dataDe']),
      periodoFinal: this.tratarCondicao(this.formPesquisa.value['dataAte']),
      descricaoLancamento: this.tratarCondicao(this.formPesquisa.value['lancamento']),
      codigoStatus: this.tratarCondicao(this.formPesquisa.value['codigoStatus']),
      valorInicial: this.tratarCondicao(this.formPesquisa.value['valorInicial']),
      valorFinal: this.tratarCondicao(this.formPesquisa.value['valorFinal']),
      page: page == undefined ? 0 : page,
      perPage: 10,
    };

    this.consultaTransacaoService.addDadosPesquisa(parametros, this.formPesquisa);

    this.extratoContaCreditoService.obterLinhasExtrato(parametros).subscribe(response => {
      console.log(response);
      this.loading.close();
      this.extratoPaginado = response;
      this.page = this.extratoPaginado.paginacao;
      this.loadingLista = false;
      this.source = this.extratoPaginado.extratos;
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });
  }

  public visualizarDetalhesExtrato(numeroTransacao: number) {
    this.router.navigate(['/detalhe-validacao/' + numeroTransacao]);
  }

  public excluirLinhas(ModalDialog) {
    ModalDialog.close();
    this.loading.open();

    this.extratoContaCreditoService.excluirLinhaCredito(this.dadosLinha).subscribe(response => {
      this.loading.close();
      this.modalConcluidoExtrato.open(null);
    }, error => {
      this.loadingLista = false;
      this.loading.close();
      this.appComponent.createAlert("Erro ao efetivar exclusão!", 'error');
    });
  }

  public recarregarPagina() {
    setTimeout(() => {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.consultaTransacaoService.setRealizaPesquisa(true);
        this.router.navigate(['/conciliacao-extrato']);
      });
    }, 500);
  }

  public changeLinhaSelecionada(event, codigoLinhaExtrato: number, codigoExtrato: number): void {
    var linha = this.extratoPaginado.extratos.find(function (p) {
      return (p.codigoLinhaExtrato == codigoLinhaExtrato && p.extratoContaCredito.codigoExtrato == codigoExtrato)
    });
    var target = event.target;

    if (target.checked) {
      this.linhasSelecionadas.push(codigoLinhaExtrato+(codigoExtrato*9999));
      this.dadosLinha.push(linha);
    } else {
      var index = this.linhasSelecionadas.indexOf(codigoLinhaExtrato+(codigoExtrato*9999));
      if (index > -1) {
        this.linhasSelecionadas.splice(index, 1);
        this.dadosLinha.splice(this.dadosLinha.indexOf(linha), 1);
      }
    }
  }

  public isLinhaSelecionada(codigoLinhaExtrato: number, codigoExtrato: number): boolean {
    return this.linhasSelecionadas.indexOf(codigoLinhaExtrato+(codigoExtrato*9999)) != -1;
  }

  public tratarCondicao(valor: any) {
    if (valor !== undefined && valor !== null && valor === '') {
      return null;
    }
    return valor;
  }

  public tratarValor(valor: any) {
    if (this.formPesquisa.get(valor).value === 0
        ||  this.formPesquisa.get(valor).value === '') {
          this.formPesquisa.get(valor).setValue(null);
      }
  }


}
